module.exports = __webpack_public_path__ + "static/media/skipped_meal.56eb1418.jpg";